import { memo, useMemo } from 'react'

import { useBoolean } from 'usehooks-ts'

import { Feature } from '@wwt/entities/search-response'

import { useMobile, useTablet } from '@/shared/lib/hooks/useBreakpoints.ts'
import { SeeMore } from '@/shared/ui/SeeMore.tsx'

import {
	MAX_OPTIONS_DESKTOP,
	MAX_OPTIONS_MOBILE,
	MAX_OPTIONS_TABLET
} from '../config/maxOptions.ts'
import { FeatureElementProps } from '../types/FeatureElementProps.ts'
import { FeatureElement } from './FeatureElement.tsx'

interface FeatureListElementsProps
	extends Omit<FeatureElementProps, 'feature' | 'onClick'> {
	features: Feature[]
	additionalForKey?: string
	onClick?: (featureName: string) => void
}

export const FeatureListElements = memo(
	({
		features,
		additionalForKey,
		onClick,
		forceIsClickable,
		...props
	}: FeatureListElementsProps) => {
		const { value: isShowAll, toggle: toggleShowAll } = useBoolean(false)

		// TODO: Re-think to rewrite this to CSS?
		// When we render all options and after that via CSS show only N we need
		const isMobile = useMobile()
		const isTablet = useTablet()

		const maxOptions = isMobile
			? MAX_OPTIONS_MOBILE
			: isTablet
				? MAX_OPTIONS_TABLET
				: MAX_OPTIONS_DESKTOP

		const isManyOptions = features.length > maxOptions

		const featuresForRender = useMemo(() => {
			return features.slice(0, isShowAll ? features.length : maxOptions)
		}, [features, isShowAll, maxOptions])

		return (
			<>
				{featuresForRender.map(feature => (
					<FeatureElement
						key={additionalForKey + feature.name}
						feature={feature}
						forceIsClickable={forceIsClickable}
						// TODO: Refactor
						onClick={() => onClick?.(feature.name)}
						{...props}
					/>
				))}

				{isManyOptions && (
					<SeeMore
						isOpened={isShowAll}
						onClick={toggleShowAll}
					/>
				)}
			</>
		)
	}
)

FeatureListElements.displayName = 'FeatureListElements'
